import { render, staticRenderFns } from "./NsHeaderRegionSelector.vue?vue&type=template&id=72767801&scoped=true&"
import script from "./NsHeaderRegionSelector.vue?vue&type=script&lang=js&"
export * from "./NsHeaderRegionSelector.vue?vue&type=script&lang=js&"
import style0 from "./NsHeaderRegionSelector.vue?vue&type=style&index=0&id=72767801&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72767801",
  null
  
)

export default component.exports